/**
 * @file: LvmiDevice.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 绿米设备
 */
import request from '@/utils/request'

/**
 * 对接绿米（绿米数据推送）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function lvmiData(data) {
  return request({
    type: 'device',
    url: 'lvmi/data',
    method: 'post',
    data
  })
}

/**
 * 网关音量调节
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function lvmiGatewayVolume(data) {
  return request({
    type: 'device',
    url: 'lvmi/gateway/volume',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/LvmiDevice.js